import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Mutations} from "@/store/enums/store.enums";
import {ServicesActions, ServicesMutation} from "@/modules/services/store/enums";

@Module
export default class Store extends VuexModule {
    renderKey = 1;

    listParams = {
        page: 1,
        results: 10,
        search: null,
        sort: [],
        filter: {}
    };

    listCache = [];
    listTotal = 0;

    activeType = 'services';
    groups = [];

    get getServicesRenderKey() {
        return 'services-' + this.renderKey;
    }

    get getServicesLastListResult() {
        return this.listCache;
    }

    get getServicesLastListTotal() {
        return this.listTotal;
    }

    get getServicesActiveType() {
        return this.activeType;
    }

    get getServicesGroups() {
        return this.groups;
    }

    @Mutation
    [ServicesMutation.SET_RENDER_UPDATE]() {
        this.renderKey++;
    }

    @Mutation
    [ServicesMutation.SET_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.listParams = listParams;
        this.listCache = listCache;
        this.listTotal = listTotal;
    }

    @Mutation
    [ServicesMutation.SET_ACTIVE_TYPE](tabName) {
        this.activeType = tabName;
    }

    @Mutation
    [ServicesMutation.SET_GROUPS](groups) {
        this.groups = groups;
    }

    @Action
    [ServicesActions.REFRESH_LIST]() {
        this.context.dispatch(ServicesActions.FETCH_LIST, this.listParams);
    }

    @Action
    [ServicesActions.FETCH_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("services/list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ServicesMutation.SET_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.GET_ITEM](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`services/get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.CREATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('services/create/', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ServicesActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.UPDATE_ITEM](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data} = payload;

            apiService.put(`services/edit/${editId}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ServicesActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.DELETE_ITEM](detailId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`services/delete/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ServicesActions.REFRESH_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.UPDATE_TRANSLATION](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data} = payload;

            apiService.put(`services/update-translation/${editId}`, data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.LIST_GROUPS]() {

        return new Promise((resolve, reject) => {

            apiService.get("services/list-groups/").then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ServicesMutation.SET_GROUPS, data.result);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.GET_GROUP_TREE](groupId) {

        return new Promise((resolve, reject) => {

            apiService.get(`services/get-group-tree/${groupId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.ASSIGN_TO_GROUP](payload) {

        return new Promise((resolve, reject) => {

            apiService.post("services/assign-to-group/", payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.REMOVE_FROM_GROUP](toGroupId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`services/remove-from-group/${toGroupId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.REORDER_GROUP](payload) {

        return new Promise((resolve, reject) => {

            const {groupId, data} = payload;

            apiService.put(`services/reorder-group/${groupId}`, payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.GET_GROUP_RELATIONS](groupId) {

        return new Promise((resolve, reject) => {

            apiService.get(`services/get-group-relations/${groupId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ServicesActions.UPDATE_GROUP_RELATIONS](payload) {

        return new Promise((resolve, reject) => {

            const {groupId} = payload;

            apiService.put(`services/update-group-relations/${groupId}`, payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

}
